// UI compartida del handoff v3 (README.md · "Componentes nuevos").
// Todo dentro de `.v3` (v3.css). Copy verbatim del prototipo.
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// ── iconos (Lucide-style, stroke 2–2.6) ─────────────────────────────
export const I = {
  back: (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M15 6l-6 6 6 6" /></svg>,
  chev: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A1A1A6" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M9 6l6 6-6 6" /></svg>,
  arrow: (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M5 12h14M13 6l6 6-6 6" /></svg>,
  check: (p) => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#0E7A3C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M5 12l5 5L20 7" /></svg>,
  bell: (p) => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" {...p}><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0" /></svg>,
  eye: (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" {...p}><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></svg>,
  mail: (p) => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#0E7A3C" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="5" width="18" height="14" rx="3" /><path d="M3 8l9 6 9-6" /></svg>,
  send: (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF4D0D" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M21 4L3 11l7 2 2 7z" /></svg>,
  signal: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0E7A3C" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M3 17l5-6 4 4 5-8 4 5" /></svg>,
  clock: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9A5B00" strokeWidth="2.4" strokeLinecap="round" {...p}><circle cx="12" cy="12" r="9" /><path d="M12 8v4l3 2" /></svg>,
  x: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B42121" strokeWidth="2.6" strokeLinecap="round" {...p}><path d="M6 6l12 12M18 6L6 18" /></svg>,
  cal: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2.2" strokeLinecap="round" {...p}><rect x="3" y="4" width="18" height="17" rx="3" /><path d="M8 2v4M16 2v4M3 10h18" /></svg>,
  card: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" {...p}><rect x="2" y="5" width="20" height="14" rx="3" /><path d="M2 10h20" /></svg>,
  pen: (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></svg>,
  wifiOff: (p) => <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" {...p}><path d="M1 1l22 22M16.7 11.4a10 10 0 0 0-2.6-1.2M5 12.5a10 10 0 0 1 5.2-2.6M8.5 16a5 5 0 0 1 7 0M12 20h.01M2 8.8a15 15 0 0 1 4.9-2.9M22 8.8a15 15 0 0 0-8.4-3.7" /></svg>,
  warn: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2.4" strokeLinecap="round" {...p}><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" /></svg>,
  google: () => <svg width="17" height="17" viewBox="0 0 24 24"><path fill="#4285F4" d="M23 12.2c0-.8-.1-1.6-.2-2.3H12v4.4h6.2a5.3 5.3 0 0 1-2.3 3.5v2.9h3.7c2.2-2 3.4-5 3.4-8.5z" /><path fill="#34A853" d="M12 23.5c3.1 0 5.7-1 7.6-2.8l-3.7-2.9c-1 .7-2.3 1.1-3.9 1.1-3 0-5.5-2-6.4-4.7H1.8v3a11.5 11.5 0 0 0 10.2 6.3z" /><path fill="#FBBC05" d="M5.6 14.2a6.9 6.9 0 0 1 0-4.4v-3H1.8a11.5 11.5 0 0 0 0 10.4l3.8-3z" /><path fill="#EA4335" d="M12 5c1.7 0 3.2.6 4.4 1.7l3.3-3.3A11.5 11.5 0 0 0 1.8 6.8l3.8 3C6.5 7 9 5 12 5z" /></svg>,
};

// Wordmark oficial (mismo SVG del prototipo: texto Inter Tight + punto).
export function Wordmark({ width = 152, dark = false }) {
  const h = Math.round(width * 41 / 152);
  return (
    <svg viewBox="48 40 1074 290" width={width} height={h} xmlns="http://www.w3.org/2000/svg" aria-label="Edge Elite">
      <text x="60" y="250" fontFamily="'Inter Tight',system-ui,sans-serif" fontSize="240" fontWeight="700" letterSpacing="-9.6" fill={dark ? '#FFFFFF' : '#1D1D1F'}>Edge Elite</text>
      <g transform="translate(1040,195)"><circle cx="38" cy="38" r="38" fill="#FF4D0D" /><path d="M19 19c10.1 8.2 10.1 31 0 38" stroke="#0A0A0C" strokeOpacity=".55" strokeWidth="5" strokeLinecap="round" fill="none" /></g>
    </svg>
  );
}

// ── header de subpantalla `.nav` ─────────────────────────────────────
export function Nav({ title, onBack, right = null, action = null }) {
  const navigate = useNavigate();
  return (
    <div className="nav">
      <button type="button" className="back" aria-label="Volver" onClick={onBack || (() => navigate(-1))}><I.back /></button>
      <h1>{title}</h1>
      {action ? action : <span className="sp">{right}</span>}
    </div>
  );
}

// ── badge de estado `.stt` ───────────────────────────────────────────
export function Stt({ kind = 'n', children }) {
  return <span className={`stt ${kind}`}><i />{children}</span>;
}

// ── toggle `.tg` 44×26 ───────────────────────────────────────────────
export function Toggle({ on, onChange, label }) {
  return (
    <button type="button" role="switch" aria-checked={!!on} aria-label={label}
      className={`tg${on ? ' on' : ''}`} onClick={() => onChange && onChange(!on)} />
  );
}

// ── estados vacíos ──────────────────────────────────────────────────
export function EmptyInline({ icon, title, children, cta, onCta, ghost }) {
  return (
    <div className="empty">
      {icon && <div className="ic">{icon}</div>}
      <h3>{title}</h3>
      {children && <p>{children}</p>}
      {cta && <button type="button" className={`cta${ghost ? ' ghost' : ''}`} onClick={onCta}>{cta}</button>}
    </div>
  );
}
export function EmptyFull({ icon, title, children, cta, onCta, extra }) {
  return (
    <div className="empty-full">
      {icon && <div className="ic">{icon}</div>}
      <h2>{title}</h2>
      {children && <p>{children}</p>}
      {cta && <button type="button" className="cta" onClick={onCta}>{cta}</button>}
      {extra}
    </div>
  );
}
export function NextUp({ emoji, liga, partido, hora, style }) {
  return (
    <div className="next-up" style={style}>
      <div className="ic"><span style={{ fontSize: 16 }}>{emoji}</span></div>
      <div style={{ minWidth: 0 }}><p className="k">Próximo · {liga}</p><p className="t">{partido}</p></div>
      <span className="tm">{hora}</span>
    </div>
  );
}

// ── offline ──────────────────────────────────────────────────────────
export function OffBar({ since }) {
  return (
    <div className="offbar" role="status">
      <i /><span><b>Sin conexión.</b>{since ? ` Mostrando datos de las ${since}` : ''}</span><span className="rt">Reintentando…</span>
    </div>
  );
}
export function Skel({ w, h, style }) {
  return <div className="skel" style={{ width: w, height: h, ...style }} />;
}
// Card skeleton con la misma silueta de .sig (para que el layout no salte)
export function SigSkeleton() {
  return (
    <div className="sig">
      <Skel w={90} h={10} />
      <Skel w={230} h={16} style={{ marginTop: 12 }} />
      <div className="sig-meta"><Skel w={70} h={26} /><Skel w={40} h={26} /><Skel w={40} h={26} /></div>
    </div>
  );
}

// ── toast (auto-oculta 6s) ───────────────────────────────────────────
const ToastCtx = createContext(() => {});
export function ToastProvider({ children }) {
  const [t, setT] = useState(null);
  const timer = useRef(null);
  const show = useCallback((msg, opts = {}) => {
    clearTimeout(timer.current);
    setT({ msg, action: opts.action || null, onAction: opts.onAction || null, ok: !!opts.ok });
    timer.current = setTimeout(() => setT(null), opts.ms || 6000);
  }, []);
  useEffect(() => () => clearTimeout(timer.current), []);
  const value = useMemo(() => show, [show]);
  return (
    <ToastCtx.Provider value={value}>
      {children}
      {t && (
        <div className={`v3-toast${t.ok ? ' ok' : ''}`} role="status">
          {t.ok ? <I.check width={16} height={16} stroke="#4ADE80" /> : <I.warn />}
          {t.msg}
          {t.action && <button type="button" className="ac" onClick={() => { setT(null); t.onAction && t.onAction(); }}>{t.action}</button>}
        </div>
      )}
    </ToastCtx.Provider>
  );
}
export const useToast = () => useContext(ToastCtx);
